import * as React from 'react';
import { IconProps } from '../types';

const IcTransaction = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#232F3E"
      d="M17.502 13a1 1 0 0 1 .116 1.993l-.116.007H5.916l3.292 3.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.095-.083-5-5c-.602-.603-.22-1.614.594-1.701L3.502 13h14Zm-.39-8.79.095.083 5 5c.602.602.22 1.614-.594 1.701L21.5 11h-14a1 1 0 0 1-.117-1.993L7.5 9h11.584l-3.292-3.293a1 1 0 0 1-.083-1.32l.083-.094a1 1 0 0 1 1.32-.083Z"
    />
  </svg>
);

export default IcTransaction;
